import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "captcha-input" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_turnstile = _resolveComponent("vue-turnstile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.captchaSiteKey)
      ? (_openBlock(), _createBlock(_component_vue_turnstile, {
          key: 0,
          "site-key": _ctx.captchaSiteKey,
          action: _ctx.captchaAction,
          size: "normal",
          modelValue: _ctx.token,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.token) = $event)),
            _ctx.handleTurnstileVerify
          ],
          ref: "turnstile"
        }, null, 8 /* PROPS */, ["site-key", "action", "modelValue", "onUpdate:modelValue"]))
      : _createCommentVNode("v-if", true),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createElementVNode("input", {
      type: "hidden",
      name: "captchaToken",
      value: _ctx.token
    }, null, 8 /* PROPS */, _hoisted_2),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(_Transition, { name: "input-error--animation" }, {
      default: _withCtx(() => [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "input-error",
              innerHTML: _ctx.error
            }, null, 8 /* PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}